import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { previousPollPage } from "../../actions/poll";
import PollConfig from "../../utils/PollConfig";

const PollNavigation = props => {
  const config = new PollConfig();
  return (
    <div className="columns">
      <div className="column has-text-left">
        <Link
          to="#"
          className="button is-medium"
          onClick={() => {
            props.previousPollPage(props.formValues, props.history);
          }}
        >
          Cofnij
        </Link>
      </div>

      <div className="column has-text-right">
        {props.page < config.pagesCount() - 1 ? (
          <button type="submit" className="button is-link is-medium  is-danger">
            Dalej
          </button>
        ) : (
          <button type="submit" className="button is-medium is-danger">
            Wyślij formularz
          </button>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    page: (state.poll && state.poll.page) || 0,
    formValues: state.form && state.form.pollForm && state.form.pollForm.values
  };
}
PollNavigation.propTypes = {
  previousPollPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  formValues: PropTypes.shape(),
  history: PropTypes.shape()
};
PollNavigation.defaultProps = {
  formValues: {},
  history: null
};

export default connect(mapStateToProps, {
  previousPollPage
})(withRouter(PollNavigation));



// WEBPACK FOOTER //
// ./src/components/poll/PollNavigation.js